import React, {FC, useCallback, useState} from "react";
import {useGetIsSubscribed} from "../../../../hooks/api/Subscribe/useGetIsSubscribed";
import {useAuth, useProfile} from "@brg/auth";
import {API, Endpoints} from "@brg/api";
import styled from "styled-components";
import {Colors} from "@brg/ui";
import {LayoutConst} from "../../../../../core";
import {useTranslation} from "react-i18next";

const Button  = styled.div<{disabled?: boolean, isSubscribed?: boolean}>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    background: ${({isSubscribed}) => isSubscribed ? Colors.geoWhite100 : Colors.galBlack100};
    border: 1px solid ${Colors.galBlack100};
    color: ${({isSubscribed}) => isSubscribed ? Colors.galBlack100 : Colors.geoWhite100};
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    border-radius: 3px;
    width: 100%;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
        height: 36px;
    }
`

export const IqmediaSubscribeButton: FC<{ designerId: string, targetType?: string }> = ({ designerId, targetType='user' }) => {

    const profile = useProfile()
    const [time, setTime] = useState(Date.now())
    const [isSubscribeLoading, setIsSubscribeLoading] = useState(false)
    const { t } = useTranslation()

    const {isSubscribed, isLoading} = useGetIsSubscribed(profile?.accountId || '', 0, designerId, targetType, time)
    const { emit } = useAuth();

    const onSubscribe = useCallback(() => {
        if(!profile?.accountId){
            emit('login_replace');
          }
        

        setIsSubscribeLoading(true)
        API.request()
            .endpoint(Endpoints.subscriptions)
            .url('/api/Subscription/' + (isSubscribed ? 'Unsubscribe' : 'Subscribe'))
            .post()
            .body({
                subscriberId: profile?.accountId || '',
                subscriberType: 0,
                targetId: designerId,
                targetType: targetType
            })
            .send()
            .then((r) => r.json())
            .then((r) => {
                setTime(Date.now())
                setIsSubscribeLoading(false)
            })
            .catch((e) => {
                setTime(Date.now())
                setIsSubscribeLoading(false)
            })
    }, [isSubscribed, isLoading, isSubscribeLoading, profile?.accountId, designerId])

    if (!designerId) return null;

    return <Button  isSubscribed={isSubscribed} onClick={onSubscribe}>
        {isSubscribed ? t('subscription.unsubscribe') : t('subscription.subscribe')}
    </Button>
}import React, {FC, useCallback, useState} from "react";
import {useGetIsSubscribed} from "../../../../hooks/api/Subscribe/useGetIsSubscribed";
import {useAuth, useProfile} from "@brg/auth";
import {API, Endpoints} from "@brg/api";
import styled from "styled-components";
import {Colors} from "@brg/ui";
import {LayoutConst} from "../../../../../core";
import {useTranslation} from "react-i18next";

const Button  = styled.div<{disabled?: boolean, isSubscribed?: boolean}>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    background: ${({isSubscribed}) => isSubscribed ? Colors.geoWhite100 : Colors.galBlack100};
    border: 1px solid ${Colors.galBlack100};
    color: ${({isSubscribed}) => isSubscribed ? Colors.galBlack100 : Colors.geoWhite100};
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    border-radius: 3px;
    width: 100%;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
        height: 36px;
    }
`

export const IqmediaSubscribeButton: FC<{ designerId: string, targetType?: string }> = ({ designerId, targetType='user' }) => {

    const profile = useProfile()
    const [time, setTime] = useState(Date.now())
    const [isSubscribeLoading, setIsSubscribeLoading] = useState(false)
    const { t } = useTranslation()

    const {isSubscribed, isLoading} = useGetIsSubscribed(profile?.accountId || '', 0, designerId, targetType, time)
    const { emit } = useAuth();

    const onSubscribe = useCallback(() => {
        if(!profile?.accountId){
            emit('login_replace');
          }
        

        setIsSubscribeLoading(true)
        API.request()
            .endpoint(Endpoints.subscriptions)
            .url('/api/Subscription/' + (isSubscribed ? 'Unsubscribe' : 'Subscribe'))
            .post()
            .body({
                subscriberId: profile?.accountId || '',
                subscriberType: 0,
                targetId: designerId,
                targetType: targetType
            })
            .send()
            .then((r) => r.json())
            .then((r) => {
                setTime(Date.now())
                setIsSubscribeLoading(false)
            })
            .catch((e) => {
                setTime(Date.now())
                setIsSubscribeLoading(false)
            })
    }, [isSubscribed, isLoading, isSubscribeLoading, profile?.accountId, designerId])

    if (!designerId) return null;

    return <Button  isSubscribed={isSubscribed} onClick={onSubscribe}>
        {isSubscribed ? t('subscription.unsubscribe') : t('subscription.subscribe')}
    </Button>
}